export const CREATE_NOTIFY_REQUEST = "CREATE_NOTIFY_REQUEST";
export const CREATE_NOTIFY_REQUEST_SUCCEEDED = "CREATE_NOTIFY_REQUEST_SUCCEEDED";
export const CREATE_NOTIFY_REQUEST_FAILED = "CREATE_NOTIFY_REQUEST_FAILED";
